import { AdminProfile, isProviderProfile, ProviderProfile } from "@/core/types";
import images from "@/utils/images";

type ProfileSidebarProps = {
  profileData: AdminProfile | ProviderProfile;
};

export function ProfileSidebar({ profileData }: ProfileSidebarProps) {
  const displayType = isProviderProfile(profileData)
    ? profileData.provider_type
    : profileData.user_type;

  return (
    <div className="ProviderProfile__short-details tw:w-full tw:rounded">
      <div className="tw:flex tw:flex-row tw:items-center tw:py-4 tw:md:flex-col tw:md:justify-center tw:md:py-0">
        <div className="tw:mx-3 tw:md:mx-0 tw:md:mt-10 tw:md:mb-6">
          <img
            alt="Customer Success avatar"
            className="tw:mx-auto tw:block"
            src={images("./common/avatar.png")}
          />
        </div>

        <div className="tw:text-white tw:text-text-white tw:md:text-center">
          <p className="tw:text-base tw:font-bold tw:md:mb-2 tw:md:text-lg">{profileData.name}</p>

          <p className="tw:text-sm">{displayType}</p>
        </div>
      </div>
    </div>
  );
}
